import { computed } from "mobx";

export default class IdaqExportModel {
  constructor(store, item){
    this.store = store;
    this.id = +item.id;
    this.name = item.name;
    this.protocol = item.protocol;
    this.host = item.host;
    this.pathname = item.pathname;
    this.username = item.username;
    this.password = item.password;
    this.idaq_id = item.idaq_id;
    this.idaq_id_end = item.idaq_id_end;
    this.status = item.status;
    this.image_source_device = item.image_source_device || [];

    this.updateFromJson(item)
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      protocol: this.protocol,
      host: this.host,
      username: this.username,
      password: this.password,
      idaq_id: this.idaq_id,
      idaq_id_end: this.idaq_id_end,
      status: this.status,
      image_source_device: this.image_source_device || [],
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.protocol = json.protocol;
    this.host = json.host;
    this.pathname = json.pathname;
    this.username = json.username;
    this.password = json.password;
    this.idaq_id = json.idaq_id;
    this.idaq_id_end = json.idaq_id_end;
    this.status = json.status;
    this.image_source_device = json.image_source_device || []
  }
}


// WEBPACK FOOTER //
// ./src/models/DataDelivery/IdaqExportModel.js